export default "__VITE_ASSET__FrzbrG1R__"